// extracted by mini-css-extract-plugin
module.exports = {"tittel":"Lenkeliste_tittel__zoxZM","lenker":"Lenkeliste_lenker__wf9My","lenke":"Lenkeliste_lenke__CDFCH"};